module.exports = __webpack_public_path__ + "static/media/logo512.dea06888.png";